import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.harvest-report-table', () => {
  import('./internal/harvest-report-table').then(({ default: Component }) => Component());
});
